import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './FinaceofficerLayout.css';
import { FProfile } from '../../financeofficer/FProfile';
import { FinanceApplication } from '../../financeofficer/financeApplication';
import FinanceofficerMenu from '../../financeofficer/financeofficermenu/FinanceofficerMenu';
import Fheader from '../../Header/Fheader';
import { FinanceofficerActivities } from '../../financeofficer/financeofficerActivities';
import { ViewApplicationFO } from '../../financeofficer/ViewApplicationFO';



interface FinaceofficerLayout {

  children?: ReactNode;
  // Define children as a ReactNod
}
const FinaceofficerLayout: React.FC<FinaceofficerLayout> = ({ children }) => {


  return (
    <div className="finace-layout-container">
      <Fheader />
      <div >
        <FinanceofficerMenu />
        <Routes>
          <Route path="/fprofile" element={<FProfile />} />
          <Route path="/fpapplications" element={<FinanceApplication />} />
          <Route path="/fiofnactivities" element={<FinanceofficerActivities />} />
          <Route path="/fviewapprove/:id" element={<ViewApplicationFO />} />
          <Route path="/fviewapplied/:id" element={<ViewApplicationFO />} />
          <Route path="/fviewall/:id" element={<ViewApplicationFO />} />
        </Routes>
      </div>
      {children}
      {/* <Footer /> */}
    </div>);
};

export default FinaceofficerLayout;
